export default {
  BusinessStockDeliveryResult: {
    header: {
      queryCode: '单号',
      outLogicWarehouseCode: '出库逻辑仓',
      outLogicWarehouseCodeText: '请输入逻辑仓编码',
    },

    table: {
      resultCode: '出库结果单号',
      odoCode: '出库通知单号',
      outTypeMeaning: '出库类型',
      status: '出库状态',
      alreadyOutQty: '已发货数量',
      outLogicWarehouseCode: '出库逻辑仓编码',
      outLogicWarehouseName: '出库逻辑仓名称',
      shopName: '销售店铺',
      channelTypeCodeMeaning: '销售渠道',
    }
  }
};
